import { CommonLayoutProps } from './types';
import { Box, Fab } from '@mui/material';
import BottomNavBar from 'src/components/BottomNavBar';
import LayoutHeader from 'src/components/LayoutHeader/LayoutHeader';
import SupportButton from 'src/components/SupportButton';
import HeaderBrand from 'src/components/LayoutHeader/HeaderBrand';
import HeaderNavigation from 'src/components/LayoutHeader/HeaderNavigation';
import HeaderCart from 'src/components/LayoutHeader/HeaderCart';
import SearchDrawerButton from 'src/components/LayoutHeader/HeaderSearchBar/variants/SearchDrawerButton';
import HeaderAddress from 'src/components/LayoutHeader/HeaderAddress';
import HeaderSupportButton from 'src/components/LayoutHeader/HeaderSupportButton';
import { useLayoutConfiguration } from 'src/common/hooks/useLayoutConfiguration';
import GridItemsGroup from 'src/components/GridItemsGroup';
import LayoutContentContainer from './LayoutContentContainer';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';
import ConditionalWrapper from 'src/components/ConditionalWrapper';
import LayoutTimer from 'src/components/LayoutTimer';
import { FlexColumnContainer } from 'src/components/styles';

export default function HomeLayout({ children }: CommonLayoutProps) {
  const { isMobile } = useAppUI();

  const {
    showBottomNav,
    showAddressSelector,
    showHeaderBrand,
    showHeaderNavigation,
    supportButtonPosition,
    showSearch,
    showMobileHeaderBrand,
    showLayoutTimer,
  } = useLayoutConfiguration();

  const showBrand = isMobile ? showMobileHeaderBrand : showHeaderBrand;

  return (
    <ConditionalWrapper
      condition={isMobile}
      wrapper={(children) => (
        <FlexColumnContainer
          sx={{ overflowY: 'hidden', maxHeight: '100vh', flexWrap: 'nowrap' }}
        >
          {children}
        </FlexColumnContainer>
      )}
    >
      <LayoutHeader>
        <ConditionalWrapper
          condition={showBrand && !isMobile}
          wrapper={(children) => (
            <GridItemsGroup columns={{ xs: 12, md: 4 }}>
              {children}
            </GridItemsGroup>
          )}
        >
          {showBrand && <HeaderBrand columns={{ xs: 12, md: 1.4 }} />}
          {showAddressSelector && (
            <HeaderAddress
              columns={{
                xs: showBrand && isMobile ? 10 : 12,
                md: 2.5,
                xl: 2.5,
              }}
            />
          )}
        </ConditionalWrapper>
        {supportButtonPosition === 'header' && <HeaderSupportButton />}
        {showSearch && <SearchDrawerButton />}
        {showHeaderNavigation && <HeaderNavigation />}
        <HeaderCart />
      </LayoutHeader>
      <LayoutContentContainer horizontalPadding={{ xs: 0, md: 1 }}>
        {children}
      </LayoutContentContainer>
      {showLayoutTimer && (
        <LayoutTimer
          variant="fab"
          interval={1000}
          enabled={true}
          size={isMobile ? 'small' : 'medium'}
        />
      )}
      {showBottomNav && <BottomNavBar />}
      {supportButtonPosition === 'floating' && (
        <Box position="fixed" bottom={20} right={20}>
          <Fab component="div" color="primary" size="large">
            <SupportButton color="inherit" size="large" variant="icon" />
          </Fab>
        </Box>
      )}
    </ConditionalWrapper>
  );
}
